var players = [];
var addPlayer = function addPlayer(player) {
  return players.push(player);
};
var removePlayer = function removePlayer(player) {
  var playerIndex = players.indexOf(player);
  if (playerIndex > -1) {
    players.splice(playerIndex, 1);
  }
};
export default {
  pauseOthers: function pauseOthers(player) {
    players.forEach(function (otherPlayer) {
      if (otherPlayer !== player) {
        otherPlayer.pause();
      }
    });
  },
  subscribe: function subscribe(player) {
    if (players.indexOf(player) === -1) {
      addPlayer(player);
    }
  },
  unsubscribe: function unsubscribe(player) {
    removePlayer(player);
  }
};